<template>
    <div>
      <div style="max-height: 500px;overflow-y: auto">
        <el-form size="small" style="margin: 0 40px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="95px" class="demo-ruleForm my-form">
          <div>
            <el-row>
              <el-col :span="19">
                <el-row>
                  <el-col :span="12" style="padding-right: 20px;box-sizing: border-box">
                    <el-form-item label="姓名" prop="name" v-if="personObj.phone">
                      <el-input class="my-form-inpt" style="width: calc(100% - 50px)" v-model="addEditForm.name" placeholder="请输入姓名"></el-input>
                      <el-button type="primary" icon="el-icon-search" @click="blurSearchPerson"></el-button>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name" v-else>
                      <el-input class="my-form-inpt" v-model="addEditForm.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="出生日期" prop="birthday">
                      <div style="width: 100%;height: 100%;display: flex">
                        <el-date-picker v-fixZoom class="my-form-inpt" style="width: 100%" v-model="addEditForm.birthday" type="date"
                                        value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
                        </el-date-picker>
                      </div>
                    </el-form-item>
                    <el-form-item label="籍贯">
                      <el-input class="my-form-inpt" v-model="addEditForm.nativeplace" placeholder="请输入籍贯"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="idcard_num">
                      <el-input class="my-form-inpt" v-model="addEditForm.idcard_num" placeholder="请输入身份证号"></el-input>
                    </el-form-item>
                    <el-form-item label="小程序账号">
                      <el-radio-group style="margin-left: 10px" v-model="addEditForm.is_open_applet">
                        <el-radio :label="0">不开通</el-radio>
                        <el-radio :label="1">开通</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="健康状况">
                      <div>
                        <div v-if="addEditForm.isHealth === 0" style="width: calc(100% - 75px);float: left">
                          <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.isHealth" placeholder="请选择" style="width: 100%" @change="changeHealth">
                            <el-option v-for="item in healthOptions" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                        <div v-else style="width: 100%">
                          <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.isHealth" placeholder="请选择" style="width: 100%" @change="changeHealth">
                            <el-option v-for="item in healthOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
                          </el-select>
                        </div>
                        <div v-if="addEditForm.isHealth === 0" style="width: 75px;float: right;text-align: right">
                          <el-button v-if="addEditForm.isHealth === 0" type="primary" plain @click="seeDisease()">查看</el-button>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="特殊情况">
                      <el-input class="my-form-inpt" placeholder="例：失独，离异，丧偶等" v-model="addEditForm.circumstances"></el-input>
                    </el-form-item>
                    <el-form-item label="服务频率" prop="frequencyid">
                      <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.frequencyid" filterable placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in frequencyOptions" :key="item.value" :label="item.frequency" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="padding-right: 20px;box-sizing: border-box">
                    <el-form-item label="性别" prop="sex">
                      <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.sex" placeholder="请选择性别" style="width: 100%">
                        <el-option v-for="item in sexOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="民族">
                      <el-select v-fixZoom class="my-form-inpt" filterable v-model="addEditForm.nation" placeholder="请选择民族" style="width: 100%">
                        <el-option v-for="item in nationOptions" :key="item.value" :label="item.value" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="联系方式" prop="phone">
                      <div v-if="isAddPerson">
                        <el-input class="my-form-inpt" type="number" v-model="addEditForm.phone" placeholder="请输入联系方式"></el-input>
                      </div>
                      <div v-else>
                        <div style="width: calc(100% - 30px);float: left">
                          <el-input class="my-form-inpt" type="number" v-model="addEditForm.phone" placeholder="请输入联系方式"></el-input>
                        </div>
                        <div style="width: 30px;float: right">
                          <div class="add-open-btn" @click="addOpenPhone()">
                            <strong>+</strong>
                          </div>
                        </div>
                        <div style="clear: both"></div>
                      </div>
                    </el-form-item>
                    <el-form-item label="身份证地址">
                      <el-input class="my-form-inpt" placeholder="请输入地址" v-model="addEditForm.idcard_address"></el-input>
                    </el-form-item>
                    <el-form-item label="血型">
                      <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.blood_type" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in bloodTypes" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="!isAddPerson" label="生命体征" prop="is_dead">
                      <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.is_dead" filterable placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in deadArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="所属项目" prop="">
                      <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.projectids" multiple collapse-tags style="width: 100%" placeholder="请选择" @change="changeProject">
                        <el-option v-for="item in projectOptions" :key="item.value" :label="item.projectname" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="接听时间段">
                       <el-time-picker v-fixZoom class="my-form-inpt" style="width: 100%" is-range v-model="timechange" range-separator="至"
                                      start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"
                                      value-format="HH:mm" @change="changeTime"></el-time-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="5">
                <div style="width: 90px;margin: auto">
                  <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false" :on-exceed="handleExceed"
                    :before-upload="beforeUpload" :on-change="getFile" list-type="picture" :file-list="fileList">
                    <img v-if="addEditForm.photourl" :src="addEditForm.photourl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <div style="font-size: 16px;text-align: center;color: #409EFF">
                  <span v-if="isAddPerson">上传头像</span>
                  <span v-if="!isAddPerson">更新头像</span>
                </div>
                <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式</span></div>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row v-if="homeObj === ''">
              <el-col :span="19" style="padding-right: 20px;box-sizing: border-box">
                <el-form-item :label="isLabel" prop="homeid">
                  <div>
                    <div style="width: calc(100% - 30px);float: left">
                      <el-row>
                        <el-col :span="12">
                          <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.cid" filterable :placeholder="isCenterName" style="width: 100%" @change="selectCommunityID">
                            <el-option v-for="item in orgcommunitys" :key="item.value" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="12">
                          <el-select v-fixZoom class="my-form-inpt" v-model="addEditForm.homeid" :placeholder="isRightName" style="width: 100%" filterable @change="selectHomeID">
                            <el-option v-for="item in selectorghomes" :key="item.id" :label="item.address" :value="item.id">
                              <span style="">{{ item.address }}</span>&nbsp;
                              <span style="color: #8492a6; font-size: 12px">{{ item.telephone }}</span>
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </div>
                    <div style="width: 30px;float: right">
                      <div class="add-open-btn" @click="addRelation()">
                        <strong>+</strong>
                      </div>
                    </div>
                    <div style="clear: both"></div>
                  </div>
                  <span style="margin-top: 10px">{{homeAddress}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24">
                <el-form-item :label="isLabel" prop="homeid">
                  <span style="margin-top: 10px">{{homeObj.address}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div v-if="personObj.phone">
        <el-row style="margin: 0 100px">
          <el-col :span="24">
            <div class="send-btn1" @click="submit('addEditForm')"><span>下一步</span></div>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <el-row style="margin: 0 100px">
          <el-col :span="12">
            <div class="cancel-btn1" @click="closeOpen()"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div v-if="isAddPerson" class="send-btn1" @click="submit('addEditForm')">
              <span>确定添加</span>
            </div>
            <div v-else class="send-btn1" @click="submit('addEditForm')">
              <span>确定更新</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 15px"></div>
      <!--患病情况-->
      <el-dialog width="600px" :visible.sync="diseaseShow" v-if="diseaseShow" :close-on-click-modal="false" append-to-body class="all-open">
        <disease-select v-if="diseaseShow" v-model="diseaseShow" :diseaseObj="diseaseObj" @changeDiseaseObj="changeDiseaseObj"></disease-select>
      </el-dialog>
      <!--新建家庭-->
      <el-dialog width="800px" :visible.sync="addShow" v-if="addShow" :close-on-click-modal="false" append-to-body class="all-open">
        <relation-add :homeAddRow="addRow" v-model="addShow"></relation-add>
      </el-dialog>
      <!--多个号码设置-->
      <el-dialog width="500px" :visible.sync="addPhoneShow" v-if="addPhoneShow" :close-on-click-modal="false" append-to-body class="all-open">
        <div class="title-top-alarm">
          <div>
            <span><span v-if="addEditForm.name !== ''">【</span>{{addEditForm.name}}<span v-if="addEditForm.name !== ''">】</span>联系方式</span>
          </div>
        </div>
        <morn-phone :phoneObj="phoneObj"></morn-phone>
      </el-dialog>
      <!--电话呼入搜索服务对象-->
      <el-dialog width="900px" :visible.sync="searchList" v-if="searchList" :close-on-click-modal="false" append-to-body class="all-open">
        <search-person-list :personListObj="personListObj" v-model="searchList" @getFatherSelect="getFatherSelect"></search-person-list>
      </el-dialog>
    </div>
</template>

<script>
import relationAdd from '../../childComponents/relationAdd'
import mornPhone from './mornPhone'
import searchPersonList from '../../../../view/components/searchPersonList'
import diseaseSelect from '../../../handlealarm/childComponents/diseaseSelect'
import {updatefile} from '../../../../api/upload'
import {addoldperson, updateoldperson, searcholdperson} from '../../../../api/serviceObject'
import {querydiseasename} from '../../../../api/home'
import {queryhomebycids} from '../../../../api/relation'
export default {
  name: 'oldPerson',
  components: {relationAdd, mornPhone, searchPersonList, diseaseSelect},
  model: {
    prop: 'quickShow',
    event: 'change'
  },
  props: {
    personObj: {
      type: Object,
      default: null
    }
  },
  data () {
    const validateIdCard = (rule, value, callback) => {
      const sfz = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value !== '') {
        if (!sfz.test(value)) {
          callback(new Error('身份证输入格式不正确'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      // 头像
      fileList: [],
      isAddPerson: true,
      sexOptions: [{name: '男', value: 1}, {name: '女', value: 0}],
      nationOptions: [],
      healthOptions: [{name: '健康', value: 1}, {name: '患病', value: 0}],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      imageUrl: '',
      diseaseIds: [],
      diseasenames: [],
      selectdiseasesids: [],
      diseasesnew: [],
      bloodTypes: [
        {name: 'A型', value: 1},
        {name: 'B型', value: 2},
        {name: 'AB型', value: 3},
        {name: 'O型', value: 4},
        {name: 'A-型', value: 5},
        {name: 'B-型', value: 6},
        {name: 'AB-型', value: 7},
        {name: 'O-型', value: 8}
      ],
      isLabel: '所属家庭/机构',
      isCenterName: '请选择小区',
      isRightName: '请选择已有家庭',
      deadArr: [{id: 0, name: '在世'}, {id: 1, name: '离世'}],
      addEditForm: {
        id: 0,
        name: '',
        birthday: '',
        sex: '',
        phone: '',
        frequencyid: '',
        projectid: '',
        circumstances: '',
        timelist: '',
        homeid: '',
        photoid: 0,
        nation: '',
        nativeplace: '',
        idcard_num: '',
        idcard_address: '',
        blood_type: '',
        have_disease: '',
        input_disease: '',
        is_dead: 0,
        projectids: [],
        is_open_applet: 0,

        orgid: '',
        cid: '',
        isHealth: '',
        photourl: '',
        csdOrg: '话务', // 待定义
        extra_info: '' // 拓展字段
      },
      addEditRules: {
        idcard_num: [
          { required: false, trigger: 'blur', validator: validateIdCard }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: '请选择出生日期', trigger: 'change' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        frequencyid: [
          { required: true, message: '请选择服务频率', trigger: 'change' }
        ],
        projectid: [
          { required: true, message: '请选择所属项目', trigger: 'change' }
        ],
        homeid: [
          { required: true, message: '请选择家庭' }
        ]
      },
      timechange: ['', ''],
      frequencyOptions: [],
      projectOptions: [],
      orgOptions: [],
      orgcommunitys: [],
      selectorghomes: [],
      homeAddress: '',
      moduletag: '',
      addShow: false,
      addRow: {
        homeTitle: '',
        cid: '',
        orgcommunitys: [],
        orgid: '',
        orgids: [],
        orgTree: [],
        // row为小区查看家庭小区信息
        row: '',
        isAll: true
      },
      // 患病情况
      diseaseShow: false,
      diseaseObj: {
        isEditMsg: true,
        isCallBack: true,
        diseasenames: [],
        diseasesnew: [],
        selectdiseasesids: [],
        diseaseids: [],
        input_disease: ''
      },
      // 多个联系号码
      addPhoneShow: false,
      phoneObj: {
        personRow: ''
      },
      searchList: false,
      personListObj: {
        searchPersons: []
      },
      homeObj: ''
    }
  },
  created () {
    /* 1、quickOpen.vue 快捷弹窗 2、phoneInAlarm.vue 电话呼入弹窗 3、doHandleAlarm.vue 处理事件弹窗 */
    // console.log(this.personObj)
    this.nationOptions = this.commonType.getNationName()
    this.golobleObject.addHomeid = this.getHomeid
    this.moduletag = this.$store.state.user.moduletag

    // 所有权限的：家庭/房间 moduletag: 3
    // 机构权限的：房间 moduletag: 2
    // 居家权限的：家庭 moduletag: 1

    if (this.moduletag === 1) {
      this.isRightName = '请选择已有家庭'
      this.isCenterName = '请选择小区'
      this.isLabel = '所属家庭'
      this.addRow.homeTitle = '新建家庭'
    } else if (this.moduletag === 2) {
      this.isRightName = '请选择已有房间'
      this.isCenterName = '请选择机构'
      this.isLabel = '所属房间'
      this.addRow.homeTitle = '新建房间'
    } else {
      this.isRightName = '请选择已有家庭/房间'
      this.isCenterName = '请选择小区/机构'
      this.isLabel = '家庭/房间'
      this.addRow.homeTitle = '新建家庭/房间'
    }
    this.getDisease()
    this.getCreateData()
    if (this.personObj.homeObj) { // 处理事件新建服务对象
      this.homeObj = this.personObj.homeObj
      this.addEditForm.cid = this.homeObj.cid
      this.addEditForm.homeid = this.homeObj.id
    }
  },
  methods: {
    getPhone () { // 处理呼入电话
      if (this.personObj.phone) {
        this.addEditForm.phone = this.personObj.phone
      }
    },
    getDisease () { // 患病类型
      querydiseasename().then(res => {
        this.diseasenames = res.data.diseasenames
        this.diseasesnew = this.commonType.getDisease(this.diseasenames)

        this.diseaseObj.diseasenames = res.data.diseasenames
        this.diseaseObj.diseasesnew = this.commonType.getDisease(this.diseasenames)
      }).catch(() => {})
    },
    // 快捷选择组织
    getOrgSelectHome (arr) {
      this.orgcommunitys = arr
    },
    getCreateData () {
      this.orgcommunitys = this.personObj.orgcommunitys
      this.addRow.orgcommunitys = this.orgcommunitys
      this.orgOptions = this.personObj.orgOptions
      this.addRow.orgTree = this.orgOptions
      this.frequencyOptions = this.personObj.frequencys
      this.projectOptions = this.personObj.projects
      for (let i = 0; i < this.frequencyOptions.length; i++) {
        if (this.frequencyOptions[i].frequency === '默认') {
          this.addEditForm.frequencyid = this.frequencyOptions[i].id
        }
      }
      for (let i = 0; i < this.projectOptions.length; i++) {
        if (this.projectOptions[i].projectname === '默认') {
          this.addEditForm.projectid = this.projectOptions[i].id
        }
      }
      this.isAddPerson = this.personObj.isAddPerson
      // console.log('新建服务对象', this.personObj)
      if (!this.isAddPerson) { // 更新服务对象 以及添加完更新
        this.selectHomebyCid(this.personObj.editRow.cid) // 家庭/房间
        this.selectOldPerson(this.personObj.editRow, this.personObj.isAddPerson) // form表单
      }
    },
    selectAdd () {
      this.isAddPerson = true
      this.homeAddress = ''
      this.addEditForm = {
        id: 0,
        name: '',
        birthday: '',
        sex: '',
        phone: '',
        frequencyid: '',
        projectid: '',
        circumstances: '',
        timelist: '',
        homeid: '',
        photoid: 0,
        nation: '',
        nativeplace: '',
        idcard_num: '',
        idcard_address: '',
        blood_type: '',
        have_disease: '',
        input_disease: '',
        projectids: [],
        is_open_applet: 0,

        orgid: '',
        cid: '',
        isHealth: '',
        photourl: '',
        csdOrg: '话务', // 待定义
        extra_info: '' // 拓展字段
      }
    },
    selectHomebyCid (id) {
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
        let obj = {
          type: 'isEdit',
          home: this.addEditForm.homeid
        }
        let cname = ''
        for (let i = 0; i < this.orgcommunitys.length; i++) {
          if (this.addEditForm.cid === this.orgcommunitys[i].id) {
            cname = this.orgcommunitys[i].name
          }
        }
        for (let i = 0; i < this.selectorghomes.length; i++) {
          if (this.addEditForm.homeid === this.selectorghomes[i].id) {
            this.homeAddress = cname + ' ' + this.selectorghomes[i].address + ' -- ' + this.selectorghomes[i].telephone
            obj.home = this.selectorghomes[i]
          }
        }
        this.$emit('getFather', obj)
      }).catch(() => {})
    },
    // 父组件调用方法传子组件 组织
    getParentOrgData (arr) {
      this.orgOptions = arr
      this.addRow.orgTree = this.orgOptions
    },
    selectCommunity (id) {
      this.addEditForm.cid = id
      this.addRow.cid = this.addEditForm.cid
      this.selectCommunityID(id)
    },
    selectHome (id) {
      this.addEditForm.homeid = id
      this.selectHomeID(id)
    },
    selectOldPerson (obj, isAddPerson) { // from表单信息（表格更新、快捷操作按钮选择服务对象）
      this.phoneObj.personRow = obj
      this.isAddPerson = isAddPerson
      this.addEditForm.id = obj.id
      this.addEditForm.name = obj.name
      this.addEditForm.birthday = obj.birthday
      this.addEditForm.sex = obj.sex
      this.addEditForm.phone = obj.phone
      this.addEditForm.frequencyid = obj.frequencyid
      this.addEditForm.projectid = obj.projectid
      this.addEditForm.circumstances = obj.circumstances
      this.addEditForm.timelist = obj.timelist
      this.addEditForm.homeid = obj.homeid
      this.addEditForm.photoid = obj.photoid
      this.addEditForm.nation = obj.nation
      this.addEditForm.nativeplace = obj.nativeplace
      this.addEditForm.idcard_num = obj.idcard_num
      this.addEditForm.idcard_address = obj.idcard_address
      this.addEditForm.blood_type = obj.blood_type
      this.addEditForm.have_disease = obj.have_disease
      this.addEditForm.input_disease = obj.input_disease
      this.addEditForm.is_dead = obj.is_dead
      this.addEditForm.cid = obj.cid
      this.addEditForm.is_open_applet = obj.is_open_applet
      this.addEditForm.extra_info = obj.extra_info
      if (obj.projectids !== '' && obj.projectids !== null) {
        this.addEditForm.projectids = obj.projectids
      } else {
        this.addEditForm.projectids = [obj.projectid]
      }
      this.addRow.cid = this.addEditForm.cid
      this.addEditForm.orgid = obj.orgid
      if (this.addEditForm.blood_type === 0) {
        this.addEditForm.blood_type = ''
      }
      if (this.addEditForm.have_disease === '') {
        this.addEditForm.isHealth = 1
        if (this.addEditForm.input_disease !== '') {
          this.addEditForm.isHealth = 0 // '其他患病'
        } else {
          this.addEditForm.isHealth = 1 // '健康'
        }
      } else {
        this.addEditForm.isHealth = 0 // '患病'
      }
      this.diseaseObj.input_disease = this.addEditForm.input_disease
      this.addEditForm.photourl = obj.photourl
      let cname = ''
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (this.addEditForm.cid === this.orgcommunitys[i].id) {
          cname = this.orgcommunitys[i].name
        }
      }
      for (let i = 0; i < this.selectorghomes.length; i++) {
        if (this.addEditForm.homeid === this.selectorghomes[i].id) {
          this.homeAddress = cname + ' ' + this.selectorghomes[i].telephone + ' -- ' + this.selectorghomes[i].address
          this.addEditForm.cid = this.selectorghomes[i].cid
          this.addRow.cid = this.addEditForm.cid
          this.addEditForm.orgid = this.selectorghomes[i].orgid
        }
      }
      if (obj.timelist !== '') {
        let date = obj.timelist.split('~')
        this.timechange = [date[0], date[1]]
      }
    },
    // 头像
    beforeUpload (file) {
      console.log(111, file, file.type)
    },
    getFile (file, fileList) {
      // const isPNG = file.raw.type === 'image/png'
      // const isLt2M = file.size / 1024 < 300
      // if (!isPNG) {
      //   this.$message.error('上传头像图片只能是 PNG 格式!')
      // }

      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 300KB!')
      // }
      this.getBase64(file.raw).then(res => {
        this.addEditForm.photourl = res
        this.imageUrl = res
        this.uploadAvatar()
      })
    },
    uploadAvatar () {
      let arr = this.imageUrl.split(',')
      let data = {
        datatype: 'image',
        data: arr[1]
      }
      updatefile(data).then(res => {
        this.addEditForm.photoid = res.data.fileid
        this.$message({
          message: '成功上传头像',
          type: 'success'
        })
      }).catch(() => {
        this.addEditForm.photourl = ''
        this.imageUrl = ''
      })
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    changeTime (val) {
      if (val.length > 0) {
        this.addEditForm.timelist = val[0] + '~' + val[1]
      } else {
        this.addEditForm.timelist = ''
      }
    },
    selectCommunityID (id) {
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (id === this.orgcommunitys[i].id) {
          if (this.orgcommunitys[i].zone_type === 1) {
            this.isRightName = '请选择已有家庭'
            this.addRow.homeTitle = '新建家庭'
          } else if (this.orgcommunitys[i].zone_type === 2) {
            this.isRightName = '请选择已有房间'
            this.addRow.homeTitle = '新建房间'
          }
        } else {
          this.isRightName = '请选择已有家庭/房间'
          this.addRow.homeTitle = '新建家庭/房间'
        }
      }
      this.addRow.cid = id
      this.addEditForm.homeid = ''
      this.homeAddress = ''
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
      }).catch(() => {})
    },
    selectHomeID (id) {
      // this.addEditForm.homeid = id
      let cname = ''
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (this.addEditForm.cid === this.orgcommunitys[i].id) {
          cname = this.orgcommunitys[i].name
        }
      }
      for (let i = 0; i < this.selectorghomes.length; i++) {
        if (id === this.selectorghomes[i].id) {
          this.homeAddress = cname + ' ' + this.selectorghomes[i].telephone + ' -- ' + this.selectorghomes[i].address
        }
      }
    },
    // 新建家庭
    addRelation () {
      this.addShow = true
    },
    getHomeid (id, address, phone, cid) { // 新建家庭返回的数据 家id 家地址 家电话 所属小区
      let obj = {
        id: id,
        address: address,
        telephone: phone,
        cid: cid
      }
      this.selectorghomes.push(obj)
      this.addEditForm.homeid = id
      let cname = ''
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (this.addEditForm.cid === this.orgcommunitys[i].id) {
          cname = this.orgcommunitys[i].name
        }
      }
      this.homeAddress = cname + ' ' + address + ' -- ' + phone
      let obj1 = {
        type: 'isAddHome',
        cid: cid,
        home: obj
      }
      this.$emit('getFather', obj1)
    },
    // 患病
    changeHealth (id) {
      if (id === 0) {
        this.diseaseShow = true
      }
    },
    seeDisease () {
      let arr = this.addEditForm.have_disease.split(',')
      this.selectdiseasesids = []
      for (let i = 0; i < arr.length; i++) {
        this.selectdiseasesids.push(parseInt(arr[i]))
      }
      this.diseaseObj.selectdiseasesids = this.selectdiseasesids
      this.diseaseShow = true
    },
    changeDisease (ids) {
      let aa = ids[0] + ''
      for (let i = 1; i < ids.length; i++) {
        aa = aa + ',' + ids[i]
      }
      this.addEditForm.have_disease = aa
    },
    closeOpen1 () {
      this.diseaseShow = false
    },
    submit1 () {
      let ids = this.selectdiseasesids
      let aa = ids[0] + ''
      for (let i = 1; i < ids.length; i++) {
        aa = aa + ',' + ids[i]
      }
      this.addEditForm.have_disease = aa
      this.diseaseShow = false
    },
    // 弹窗患病选择
    changeDiseaseObj (obj) {
      this.addEditForm.have_disease = obj.have_disease
      this.addEditForm.input_disease = obj.input_disease
      // console.log(this.addEditForm)
      this.diseaseShow = false
    },
    blurSearchPerson () {
      if (this.personObj.phone && this.addEditForm.name !== '') { // 电话呼入 家庭无服务对象 创建服务对象搜索
        let data = {
          lessname: this.addEditForm.name,
          page: 1,
          size: 888
        }
        searcholdperson(data).then(res => {
          this.personListObj.searchPersons = res.data.persons
          if (this.personListObj.searchPersons.length > 0) {
            this.searchList = true
          }
        }).catch(() => {})
      }
    },
    getFatherSelect (person) {
      // console.log(person)
      let obj1 = { // 处理电话呼入新建服务对象
        type: 'handle',
        addEditForm: person
      }
      this.$emit('getFather', obj1)
    },
    changeProject () {
      if (this.addEditForm.projectids.length > 0) {
        this.addEditForm.projectid = this.addEditForm.projectids[this.addEditForm.projectids.length - 1]
      }
    },
    closeOpen () { // 取消
      let obj = {
        type: 'close'
      }
      this.$emit('getFather', obj)
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let data = {
                id: this.addEditForm.id,
                name: this.addEditForm.name,
                birthday: this.addEditForm.birthday,
                sex: this.addEditForm.sex,
                phone: this.addEditForm.phone,
                frequencyid: this.addEditForm.frequencyid,
                projectid: this.addEditForm.projectid,
                circumstances: this.addEditForm.circumstances,
                timelist: this.addEditForm.timelist,
                homeid: this.addEditForm.homeid,
                photoid: this.addEditForm.photoid,
                nation: this.addEditForm.nation,
                nativeplace: this.addEditForm.nativeplace,
                idcard_num: this.addEditForm.idcard_num,
                idcard_address: this.addEditForm.idcard_address,
                blood_type: this.addEditForm.blood_type,
                have_disease: this.addEditForm.have_disease,
                input_disease: this.addEditForm.input_disease,
                projectids: this.addEditForm.projectids,
                is_open_applet: this.addEditForm.is_open_applet
              }
              if (data.blood_type === '') {
                data.blood_type = 0
              }
              if (this.addEditForm.isHealth === 1) {
                data.have_disease = ''
                data.input_disease = ''
              }
              if (this.addEditForm.projectid === '') {
                data.projectid = 0
              }
              if (this.isAddPerson) {
                addoldperson(data).then(res => {
                  if (this.$route.path === '/serviceObject') {
                    this.golobleObject.updateTableSerObj()
                  }
                  if (this.personObj.phone) {
                    let obj1 = { // 处理电话呼入新建服务对象 处理事件家庭查询无服务对象新建服务对象
                      type: 'handle',
                      isAddPerson: this.isAddPerson,
                      personid: res.data.personid,
                      addEditForm: this.addEditForm
                    }
                    this.$emit('getFather', obj1)
                  } else {
                    this.$confirm('是否绑定穿戴设备?', '提示', {
                      confirmButtonText: '绑定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      center: true
                    }).then(() => {
                      let oldPerson = data
                      oldPerson.id = res.data.personid
                      let obj = {
                        type: 'bind',
                        oldPerson
                      }
                      this.$emit('getFather', obj)
                    }).catch(() => {
                      let obj = {
                        type: 'close'
                      }
                      this.$emit('getFather', obj)
                    })
                  }
                  this.$notify({
                    title: '成功',
                    message: '成功添加服务对象',
                    type: 'success',
                    duration: 2000
                  })
                }).catch(() => {
                  this.$notify.error({
                    title: '失败',
                    message: '添加服务对象失败'
                  })
                })
              } else {
                data.is_dead = this.addEditForm.is_dead
                data.extra_info = this.addEditForm.extra_info
                updateoldperson(data).then(res => {
                  this.$notify({
                    title: '成功',
                    message: '成功编辑服务对象',
                    type: 'success',
                    duration: 2000
                  })
                  if (this.$route.path === '/serviceObject') {
                    this.golobleObject.updateTableSerObj()
                  }
                  let obj22 = {
                    type: 'close'
                  }
                  this.$emit('getFather', obj22)
                }).catch(() => {})
              }
            } else {
              console.log('error submit!!')
              return false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addOpenPhone () {
      this.addPhoneShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/quick/components/oldPerson.vue